import React, { FC } from 'react';
import { ListItem } from './ListItem';
import { Card } from 'antd';
import { OffersListResponse } from 'logic/api-models/api-models';
import styled from 'styled-components';
import { ListHeader } from './ListHeader';

const InstitutesList = styled.ul`
  padding-inline-start: 0;
  margin-bottom: 0;
`;

const ListCard = styled(Card)`
  .ant-card-body {
    padding: 0;
  }
`;

type Props = {
  instituteOffers?: OffersListResponse;
};

export const OfferListTable: FC<Props> = ({ instituteOffers }) => {
  return (
    <ListCard>
      <InstitutesList>
        <ListHeader />
        {instituteOffers?.results?.map((offer, idx) => (
          <ListItem {...offer} key={idx} />
        ))}
      </InstitutesList>
    </ListCard>
  );
};
